// --- src/App.js ---
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Layout and Pages
import Layout from "./components/Layout";
import Hero from "./pages/Hero";
import About from "./pages/About";
import Listings from "./pages/Listings";
import Benefits from "./pages/Benefits";
import AllListings from "./pages/AllListings";
import ScrollToTop from "./utils/ScrollToTop";
import ListingDetails from "./pages/ListingDetails";
import NotFound from "./pages/NotFound";
import Services from "./pages/Services";
import WhatsAppButton from "./components/WhatsAppBtn";

// Home grouped as a single page
const Home = () => (
  <>
    <Hero />
    <Services />
    <About />
    <Listings />
    <Benefits />
    {/* <Testimonials /> */}
    {/* <Contact /> */}
    {/* <Newsletter /> */}
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/all-listings" element={<AllListings />} />
          <Route path="/listing/:id" element={<ListingDetails />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <WhatsAppButton /> {/* Add the WhatsAppButton here */}
    </Router>
  );
}

export default App;